<div class="breadcrumb">
  <div class="breadcrumb__content">
    <p-breadcrumb [model]="items" [home]="home"></p-breadcrumb>
  </div>
</div>
